import { Injectable } from '@angular/core';
import { AbstractEntityValidator } from '@app/shared/validator/AbstractEntityValidator';
import { EntityCV } from '@app/shared/model/cv/EntityCV.model';
import { SpinnerService } from '@app/core/spinner/spinner.service';
import { SeasonService } from '../service/season.service';

@Injectable({
  providedIn: 'root'
})
export class SeasonValidatorService extends AbstractEntityValidator {

  regExp = (/[WS]\d{2}/);

  constructor(
    public spinner: SpinnerService,
    public seasonService: SeasonService
  ) {
    super(spinner, seasonService, EntityCV.all.SEASON);
  }

  validateFormat(value: string): boolean {
      return this.regExp.test(value);
  }

}
